import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpResponse,
  HttpHeaders,
  HttpParams,
  HttpEvent, HttpErrorResponse, HttpEventType, HttpProgressEvent

} from "@angular/common/http";
import { ConfigLoaderService } from '../../Shared/Services/Config/config-loader.service';
import { map, filter, catchError, mergeMap } from "rxjs/operators";
import { Observable } from 'rxjs';
import { Deserializable } from '../Model/deserializable.model';
import { SessionState } from 'http2';
import { AnySoaRecord } from "dns";
import { tap, last } from 'rxjs/operators'


@Injectable({
  providedIn: "root",
})

export class ServiceRepository {

  AccessToken = sessionStorage.getItem("AccessToken")?.toString();




  constructor(
    private _http: HttpClient,
    private _configLoaderService: ConfigLoaderService) { }


  public downloadfile = (route: string, body: any) => {

    if (ConfigLoaderService.settings.env.name.toUpperCase() == "DEVELOPMENT") {
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + this.AccessToken,
      });
      return this._http
      .post(this.createCompleteRoute(route), body, {
        headers: header,
        responseType: 'blob',
        reportProgress: true,
        observe: 'events'
      })
      .pipe(map((response) => response));
    }
    else
    {
      return this._http
      .post(this.createCompleteRoute(route), body, {
        responseType: 'blob',
        reportProgress: true,
        observe: 'events'
      })
      .pipe(map((response) => response));

    }
   
  };



  public getDatawithbody = (route: string, body: any) => {
    if (ConfigLoaderService.settings.env.name.toUpperCase() == "DEVELOPMENT") {
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + this.AccessToken,
      });
      return this._http
      .post(this.createCompleteRoute(route), {  headers: header,observe: body })
      .pipe(map((response) => response));
    }
    else{
      return this._http
      .post(this.createCompleteRoute(route), { observe: body })
      .pipe(map((response) => response));
    }
    
  };



  public getDatawitHeaders = (route: string) => {

    if (ConfigLoaderService.settings.env.name.toUpperCase() == "DEVELOPMENT") {
      // const headers = new HttpHeaders().set(
      //   "Content-Type",
      //   "application/json"
      // );
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + this.AccessToken,
      });
      return this._http
        .get(this.createCompleteRoute(route), { headers: header })
        .pipe(map((response) => response));
    }
    else {

      return this._http
        .get(this.createCompleteRoute(route))
        .pipe(map((response) => response));

    }
  };





  public getDatawitheadersandParameters1 = (route: string, params: HttpParams) => {

    if (ConfigLoaderService.settings.env.name.toUpperCase() == "DEVELOPMENT") {

      const headers = new HttpHeaders().set(
        "Authorization",
        "bearer " + this.AccessToken
      );
      return this._http
        .get(this.createCompleteRoute(route), { headers: headers, params: params })
        .pipe(map((response) => response));
    }
    else {

      return this._http
        .get(this.createCompleteRoute(route))
        .pipe(map((response) => response));

    }

  };


  public createwithoutToken = (route: string) => {
    const header = new HttpHeaders({
      "Content-Type": "application/json"
    });
    return this._http
      .post(
        this.createCompleteRoute(route),
        null,
        { headers: header, observe: "response" }
        // this.generateHeaders()
      )
      .pipe(map((response) => response));

  }
  public create = (route: string) => {

    if (ConfigLoaderService.settings.env.name.toUpperCase() == "DEVELOPMENT") {
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + this.AccessToken,
      });

      return this._http
        .post(
          this.createCompleteRoute(route),
          null,
          { headers: header, observe: "response" }
          // this.generateHeaders()
        )
        .pipe(map((response) => response));
    }
    else {
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        // Authorization: "bearer " + this.AccessToken1,
      });

      return this._http
        .post(
          this.createCompleteRoute(route),
          null,
          { headers: header, observe: "response" }
          // this.generateHeaders()
        )
        .pipe(map((response) => response));

    }


  };

  public createWithBody = (route: string, body: any) => {

    if (ConfigLoaderService.settings.env.name.toUpperCase() == "DEVELOPMENT") {
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + this.AccessToken,
      });

      return this._http
        .post(
          this.createCompleteRoute(route),
          body,
          { headers: header, observe: "response" }
          // this.generateHeaders()
        )
        .pipe(map((response) => response));
    }
    else {
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        // Authorization: "bearer " + this.AccessToken1,
      });

      return this._http
        .post(
          this.createCompleteRoute(route),
          body,
          { headers: header, observe: "response" }
          // this.generateHeaders()
        )
        .pipe(map((response) => response));

    }


  };

  public upload = (route: string, data: FormData) => {
    const headers = new HttpHeaders()
    headers.delete('Content-Type');
   
    return this._http
      .post(this.createCompleteRoute(route), data, {
        headers: headers,
        reportProgress: true,
        observe: 'events'
       
      })
      .pipe(map((response) => response));

  }


  public postToken(route: string, userId: string, password: string) {

    var headers = new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    let urlSearchParams = new URLSearchParams();
    urlSearchParams.set("grant_type", "password");
    urlSearchParams.set("userId", userId);
    urlSearchParams.set("Password", password);
    let body = urlSearchParams.toString();
    return this._http.post(this.createCompleteRoute(route), body, {
      headers
    }).pipe(map((response: any) => response));

    // const header = new HttpHeaders({
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // })
 
    // let data = "username=" + userId + "&password=" + password + "&grant_type=" + "password";
    // return this._http
    //   .post(
    //     this.createCompleteRoute(route),
    //     data,
    //     //{ userId: userId, password: password },
    //      { headers: header, responseType: "json" }
    //     // this.generateHeaders()
    //   )
    //   .pipe(map((response: any) => response));
  }

  public createCompleteRoute = (route: string) => {
    let envAddress: string;
    envAddress = ConfigLoaderService.settings.AppSettings.apiUrl;
    return envAddress + route;
  };

  public generateHeaders = () => {
    this.AccessToken = sessionStorage.getItem("AccessToken")?.toString()
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer" + this.AccessToken,
      }),
    };
  };

  public generatehttpHeaders = (token: any) => {
    return new HttpHeaders().set("Authorization", "Bearer" + token);
  };

  public getIPAddress() {
    return this._http.get("https://api.ipify.org/?format=json");
  }


  getAll<T>(route: string, params: HttpParams): Observable<T> {
    if (ConfigLoaderService.settings.env.name.toUpperCase() == "DEVELOPMENT") {
    
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + this.AccessToken,
      });
      return this._http
      .get<T>(this.createCompleteRoute(route),{ headers: header , params: params })
      .pipe()
    }
    else {
      return this._http
        .get<T>(this.createCompleteRoute(route), { params: params })
        .pipe()
    }

  }














}
